var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAdd = function SvgIconAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12Z",
    fill: "#FF9800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4902 12.2425L18.4903 12.2425L18.4902 12.2375C18.4887 12.0865 18.4275 11.9422 18.32 11.8362L18.3186 11.8349C18.2134 11.7327 18.0725 11.6754 17.9258 11.6753H17.9255H12.8048V6.5544V6.55414C12.8046 6.40743 12.7474 6.26654 12.6452 6.16129C12.5389 6.05178 12.3927 5.98999 12.2401 5.98999C12.0874 5.98999 11.9413 6.05178 11.8349 6.16129L12.0143 6.33546L11.8349 6.16129C11.7327 6.26654 11.6755 6.40743 11.6754 6.55414V6.5544V11.6753H6.55463H6.55438C6.40767 11.6754 6.26677 11.7327 6.16153 11.8349C6.05202 11.9412 5.99023 12.0873 5.99023 12.24C5.99023 12.3926 6.05202 12.5388 6.16153 12.6451C6.26677 12.7473 6.40767 12.8046 6.55438 12.8047H6.55463H11.6754V17.9256V17.9258C11.6755 18.0725 11.7327 18.2134 11.8349 18.3187C11.9413 18.4282 12.0874 18.49 12.2401 18.49C12.3927 18.49 12.5389 18.4282 12.6452 18.3187C12.7474 18.2134 12.8046 18.0725 12.8048 17.9258V17.9256V12.8047H17.9255H17.9258C18.0725 12.8046 18.2134 12.7473 18.3186 12.6451L18.3186 12.6451L18.32 12.6438C18.4275 12.5378 18.4887 12.3935 18.4902 12.2425Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_add.ff09777a.svg";
export { ForwardRef as ReactComponent };